import {DatePipe} from '@angular/common';
import {GridColumn} from '@q9elements/ui-kit/components';

const datePipe = new DatePipe('en-US');

const formatDate = (value: any): string => {
  if (!value || value === 'Could not fetch the data.') {
    return value || '';
  }

  const formatted = datePipe.transform(value, 'yyyy-MM-dd, HH:mm');
  return formatted || value;
};

export const impactGridViewColumns: GridColumn[] = [
  {field: 'sourceParentObject', title: 'Source parent'},
  {field: 'sourceManagedPackage', title: 'Source Managed Package'},
  {
    field: 'sourceLastRun',
    title: 'Source Last Run',
    transform: (row: any) => formatDate(row.sourceLastRun)
  },
  {field: 'sourceActive', title: 'Source Active'},
  {field: 'sourceManaged', title: 'Managed Source'},
  {field: 'sourceType', title: 'Source type'},
  {field: 'sourceApiName', title: 'Source API name'},
  {field: 'sourceLabel', title: 'Source label'},
  {field: 'write', title: 'Write'},
  {field: 'read', title: 'Read'},
  {field: 'triggerType', title: 'Trigger type'},
  {field: 'triggerAction', title: 'Trigger action'},
  {field: 'relationshipDescription', title: 'Relationship description'},
  {field: 'dependentType', title: 'Dependent type'},
  {field: 'dependentApiName', title: 'Dependent API name'},
  {field: 'dependentLabel', title: 'Dependent label'},
  {field: 'dependentParentObject', title: 'Dependent parent'},
  {field: 'dependentManagedPackage', title: 'Dependent Managed Package'},
  {
    field: 'dependentLastRun',
    title: 'Dependent Last Run',
    transform: (row: any) => formatDate(row.dependentLastRun)
  },
  {field: 'dependentActive', title: 'Dependent Active'},
  {field: 'dependentManaged', title: 'Managed Dependent'}
];

export const CUSTOMIZABLE_COLUMNS = {
  general: ['write', 'read', 'triggerType', 'triggerAction'],
  source: [
    'sourceParentObject',
    'sourceManagedPackage',
    'sourceLastRun',
    'sourceActive',
    'sourceManaged'
  ],
  dependent: [
    'dependentParentObject',
    'dependentManagedPackage',
    'dependentLastRun',
    'dependentActive',
    'dependentManaged'
  ]
};
